import { createRoute } from '@tanstack/react-router';
import { onboardingParentRoute } from 'pages/shared/Onboarding/onboardingParentRoute';
import { z } from 'zod';

export const onboardingSearchPharmacyRoute = createRoute({
  getParentRoute: () => onboardingParentRoute,
  validateSearch: z.object({
    phoneNumber: z.string().optional(),
  }),
  path: '/search_pharmacy',
}).lazy(() =>
  import('pages/shared/Onboarding/SearchPharmacy/SearchPharmacyPage').then((d) => d.Route)
);
